var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureGreen735Ee83D5Efa4Aacc3C43C627F4626Bf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 811,
    viewBox: "0 0 367 811",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-97 405.495V58.697C-97 6.47487 -33.744 -19.6427 3.20905 17.3189L147.111 161.288L349.86 364.117C372.713 386.988 372.713 424.015 349.86 446.886L147.111 649.715L3.20905 793.684C-33.7309 830.646 -97 804.515 -97 752.306V405.508V405.495Z",
    fill: "#77A042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureGreen735Ee83D5Efa4Aacc3C43C627F4626Bf);
export default __webpack_public_path__ + "static/media/figure-green.735ee83d5efa4aacc3c43c627f4626bf.735ee83d5efa4aacc3c43c627f4626bf.svg";
export { ForwardRef as ReactComponent };